import React from 'react';

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text-content">
            <h1 className="hero-title">
              Gear Up Before the Rest.
            </h1>
            <p className="hero-subtitle">
              THE LATEST DROPS FROM{' '}
              <span className="brand-highlight">LS2</span>,{' '}
              <span className="brand-highlight">AXOR</span>,{' '}
              <span className="brand-highlight">RAIDA</span>,{' '}
              <span className="brand-highlight">SMK</span>,{' '}
              <span className="brand-highlight">DSG</span>,{' '}
              <span className="brand-highlight">SOLACE</span>,{' '}
              <span className="brand-highlight">BLU ARMOR</span>{' '}
              AND MANY MORE. AVAILABLE HERE FIRST. EXPERIENCE THE ULTIMATE IN RIDER PROTECTION AT OUR PIMPRI-CHINCHWAD SHOWROOM.
            </p>
          </div>

          <div className="hero-spline-container">
            <div className="spline-wrapper">
              <img
                src="/images/hero-helmet.png"
                alt="LS2 FF805 Thunder Carbon Helmet"
                className="hero-helmet-image"
                draggable={false}
                onContextMenu={(e) => e.preventDefault()}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
